module.exports = __webpack_public_path__ + "img/finalizar.e442b89a.svg";